/* eslint-disable arrow-body-style */
/* eslint-disable react/prop-types */
import React from 'react';
import Lottie from "lottie-react";
import cubeDanceB from './01_Cube_Dance_B.json';

const CubeDance = (props) => {
    return (
        <Lottie animationData={JSON.parse(JSON.stringify(cubeDanceB))} {...props}/>
    );
}

export default CubeDance;



// WEBPACK FOOTER //
// ./frontend/pages/LiveMarkets/animations/headerCubes/cubeDance.jsx